import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';
const phoneUtil = PhoneNumberUtil.getInstance();
export const formatPhoneNumber = (phone, format = 'standard', region = 'US') => {
    try {
        const outputFormat = format === 'national'
            ? PhoneNumberFormat.NATIONAL
            : format === 'international'
                ? PhoneNumberFormat.INTERNATIONAL
                : format === 'uri'
                    ? PhoneNumberFormat.RFC3966
                    : PhoneNumberFormat.E164;
        const parsed = phoneUtil.parse(phone, region);
        const isValid = phoneUtil.isValidNumberForRegion(parsed, region);
        return isValid ? phoneUtil.format(parsed, outputFormat) : phone;
    }
    catch {
        return phone;
    }
};
//# sourceMappingURL=index.js.map